import { useGetDocument } from 'pages/documents_v2/hooks/useGetDocument';
import { useEntityTemplateParameters } from 'pages/documents_v2/hooks/useEntityTemplateParameters';
import { entityTypes } from 'pages/translation/config/Constants';
import { useIsEditMode } from 'pages/documents_v2/hooks/useIsEditMode';
import { BooleanParam, useQueryParam } from 'use-query-params';
import { useGetActiveVariant } from 'pages/documents_v2/views/edit_area/hooks/useGetActiveVariant';
import { useContext } from 'react';
import { AreaContext } from 'pages/documents_v2/views/edit_area/context/AreaContext';

export function useCanAddNewBlocks(area) {
    const document = useGetDocument();
    const documentLevelRestrictions = useEntityTemplateParameters(document, entityTypes.DOCUMENT, document);
    const restrictions = useEntityTemplateParameters(area, 'area', document);
    const isEditMode = useIsEditMode();
    const [compareBlocksEnabled] = useQueryParam('compare', BooleanParam);
    const { selectedHistoryVersion } = useContext(AreaContext);
    const activeVariant = useGetActiveVariant();

    if (!isEditMode || compareBlocksEnabled === true || selectedHistoryVersion !== undefined) {
        return false;
    }

    if (activeVariant && activeVariant.parentId !== null) {
        return false;
    }

    if (document?.modelId) {
        return true;
    }

    const canOnlyUseAsWhole = documentLevelRestrictions?.composition
        ? !documentLevelRestrictions?.composition?.includes('canOnlyUseAsWhole')
        : true;

    return canOnlyUseAsWhole && restrictions?.canAddFreeBlocks;
}
